/**
 * @generated SignedSource<<a4e03ed17b4f836def482a262f9d2d4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueTypeEntry$data = {
  readonly description: string | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "IssueTypeEntry";
};
export type IssueTypeEntry$key = {
  readonly " $data"?: IssueTypeEntry$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypeEntry">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueTypeEntry",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "IssueType",
  "abstractKey": null
};

(node as any).hash = "b6c1b48d2b025b2db1d555f27f7fbbc7";

export default node;
